import client from './client';

export const listWebhooks  = (orgId)               => client.get(`/api/orgs/${orgId}/webhooks`);
export const createWebhook = (orgId, data)         => client.post(`/api/orgs/${orgId}/webhooks`, data);
export const deleteWebhook = (orgId, webhookId)    => client.delete(`/api/orgs/${orgId}/webhooks/${webhookId}`);
export const testWebhook   = (orgId, webhookId)    => client.post(`/api/orgs/${orgId}/webhooks/${webhookId}/test`);

// Inbound ATS (Trust Sprint P0-07): per-org Greenhouse signing secret, OWNER/ADMIN only.
export const getGreenhouseWebhookSecret = (orgId) => client.get(`/api/orgs/${orgId}/integrations/ats/greenhouse`);
